/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auto_ScrollInputs */

const th_auto_scroll = /** @type {(inputs: Auto_ScrollInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`เลื่อนอัตโนมัติ`)
};

const en_auto_scroll = /** @type {(inputs: Auto_ScrollInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Auto-scroll`)
};

const ja_auto_scroll = /** @type {(inputs: Auto_ScrollInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`自動スクロール`)
};

const zh_auto_scroll = /** @type {(inputs: Auto_ScrollInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`自动滚动`)
};

const es_auto_scroll = /** @type {(inputs: Auto_ScrollInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Desplazamiento automático`)
};

const pt_auto_scroll = /** @type {(inputs: Auto_ScrollInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rolagem automática`)
};

const id_auto_scroll = /** @type {(inputs: Auto_ScrollInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gulir otomatis`)
};

const fr_auto_scroll = /** @type {(inputs: Auto_ScrollInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Défilement automatique`)
};

const tl_auto_scroll = /** @type {(inputs: Auto_ScrollInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Awtomatikong mag-scroll`)
};

const vi_auto_scroll = /** @type {(inputs: Auto_ScrollInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tự cuộn`)
};

const ko_auto_scroll = /** @type {(inputs: Auto_ScrollInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`자동 스크롤`)
};

const de_auto_scroll = /** @type {(inputs: Auto_ScrollInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Automatisch scrollen`)
};

const ru_auto_scroll = /** @type {(inputs: Auto_ScrollInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Автопрокрутка`)
};

const tr_auto_scroll = /** @type {(inputs: Auto_ScrollInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Otomatik kaydır`)
};

const it_auto_scroll = /** @type {(inputs: Auto_ScrollInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Scorrimento automatico`)
};

const pl_auto_scroll = /** @type {(inputs: Auto_ScrollInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Przewijaj automatycznie`)
};

const uk_auto_scroll = /** @type {(inputs: Auto_ScrollInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Автопрокручування`)
};

const hi_auto_scroll = /** @type {(inputs: Auto_ScrollInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`स्वतः स्क्रॉल`)
};

const ar_auto_scroll = /** @type {(inputs: Auto_ScrollInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تمرير تلقائي`)
};

const ms_auto_scroll = /** @type {(inputs: Auto_ScrollInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tatal automatik`)
};

const bn_auto_scroll = /** @type {(inputs: Auto_ScrollInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`স্বয়ংক্রিয় স্ক্রল`)
};

const zh_tw2_auto_scroll = /** @type {(inputs: Auto_ScrollInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`自動捲動`)
};

const zh_hk2_auto_scroll = /** @type {(inputs: Auto_ScrollInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`自動捲動`)
};

const ur_auto_scroll = /** @type {(inputs: Auto_ScrollInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`خودکار اسکرول`)
};

const fa_auto_scroll = /** @type {(inputs: Auto_ScrollInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`پیمایش خودکار`)
};

const sw_auto_scroll = /** @type {(inputs: Auto_ScrollInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sogeza kiotomatiki`)
};

const nl_auto_scroll = /** @type {(inputs: Auto_ScrollInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Automatisch scrollen`)
};

/**
* | output |
* | --- |
* | "Auto-scroll" |
*
* @param {Auto_ScrollInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const auto_scroll = /** @type {((inputs?: Auto_ScrollInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auto_ScrollInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_auto_scroll(inputs)
	if (locale === "ja") return ja_auto_scroll(inputs)
	if (locale === "zh") return zh_auto_scroll(inputs)
	if (locale === "es") return es_auto_scroll(inputs)
	if (locale === "pt") return pt_auto_scroll(inputs)
	if (locale === "id") return id_auto_scroll(inputs)
	if (locale === "fr") return fr_auto_scroll(inputs)
	if (locale === "tl") return tl_auto_scroll(inputs)
	if (locale === "vi") return vi_auto_scroll(inputs)
	if (locale === "ko") return ko_auto_scroll(inputs)
	if (locale === "de") return de_auto_scroll(inputs)
	if (locale === "ru") return ru_auto_scroll(inputs)
	if (locale === "tr") return tr_auto_scroll(inputs)
	if (locale === "it") return it_auto_scroll(inputs)
	if (locale === "pl") return pl_auto_scroll(inputs)
	if (locale === "uk") return uk_auto_scroll(inputs)
	if (locale === "hi") return hi_auto_scroll(inputs)
	if (locale === "ar") return ar_auto_scroll(inputs)
	if (locale === "ms") return ms_auto_scroll(inputs)
	if (locale === "bn") return bn_auto_scroll(inputs)
	if (locale === "zh-TW") return zh_tw2_auto_scroll(inputs)
	if (locale === "zh-HK") return zh_hk2_auto_scroll(inputs)
	if (locale === "ur") return ur_auto_scroll(inputs)
	if (locale === "fa") return fa_auto_scroll(inputs)
	if (locale === "sw") return sw_auto_scroll(inputs)
	if (locale === "nl") return nl_auto_scroll(inputs)
	return en_auto_scroll(inputs)
});